/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import CheckboxFilterMenu from '../../containers/CheckboxFilterMenu';

export const helperFunctions = {
  queuesFilter: (onChange, tableType, allActive) => queuesFilter(onChange, tableType, allActive),
  filterMethod: ({ value = 'All' }, { _original }, filterValues, allActive) => {
    const data = _original;
    return value === 'All' || allActive
      ? allActive
      : filterValues.map(({ id }) => id).includes(data.queueId);
  }
};

export default function(queues, tableType, filterValues, allActive) {
  const queuesColumn = {
    Header: 'Queues',
    show: queues,
    sortable: false,
    id: 'queues',
    minWidth: 140,
    accessor: d => d.queueName,
    filterMethod: (filter, row) => helperFunctions.filterMethod(filter, row, filterValues, allActive),
    Filter: ({ onChange }) => helperFunctions.queuesFilter(onChange, tableType, allActive),
    Cell: ({ value }) =>
      value ? (
        <span title={value}>{value}</span>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <span>--</span>
        </div>
      )
  };

  queuesColumn.Cell.propTypes = { value: PropTypes.any };

  return queuesColumn;
}

export function queuesFilter(onChange, tableType, allActive) {
  return (
    <CheckboxFilterMenu
      menuType="Queues"
      tableType={tableType}
      buttonType="columnFilter"
      selectionType="checkbox"
      updateFilter={onChange}
      hasActiveFilter={!allActive}
    >
      Queues
    </CheckboxFilterMenu>
  );
}
